export interface OeeData {
    Key: string;
    OeeType: string;
    MajorOee: MajorOee;
    MinorOee: MinorOee[];
    Description: string;
}

interface MajorOee {
    ElementName: string;
    OeeGuid: string;
    PerformanceGuid: string;
    QualityGuid: string;
    AvailabilityGuid: string;
}

interface MinorOee {
    ElementName: string;
    ElementGuid: string;
    OeeGuid: string;
    Alias: string;
}

export async function GetOeeData(elementGuid: string) {
    const apiUrl = process.env.REACT_APP_API_URL;

    const url = `${apiUrl}/teams/oee?eguid=${elementGuid}`;

    try {
        const response = await fetch(url, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
            }
        });

        if (response.ok) {
            const data: OeeData = await response.json();
            return data;
        }
    } catch (error) {
        console.error("Failed to fetch data", error);
        return null;
    }
}
